import styled, { keyframes } from 'styled-components';
import Grid from 'styled-components-grid';
import {
  pb, mb, my, pl
} from 'styled-components-spacing';

import {
  MoveLeftArrow,
  MoveRightArrow,
  HospitalImage,
  DoctorImageIcon,
  DepartmentIcon,
  IconLocation,
  PlayIcon,
  VideoImage,
  WrittenImage,
  VideoAppointment
} from '@images/svg/index';
import { StyledCoverMaxWidth } from '@components/Wrappers';

import breakpoint from 'styled-components-breakpoint';
import { LinkBack } from '@components';
import theme from '@theme';


import { RichTextStyle } from '@lib/styles/richtextEditiorStyles';

const { colors } = theme;

export const StyledCover = styled(StyledCoverMaxWidth)`
  ${pb(0)}
  ${mb(4)}
  margin-left: auto;
  margin-right: auto;
  padding: 20px;

  ${breakpoint('desktop')`
    ${mb(5)}
  `}

  ${breakpoint('mobile', 'desktop')`
    margin:1%; 
    padding:1%; 
  `}


`;

export const PlaceholderSpacer = styled.div`
  background-color: Azure;
  height: 100%;
  width: 100%;
`;

export const StyledLinkBack = styled(LinkBack)`
  ${my(4)}
  display: inline-block;
`;


export const StyledWrapper = styled.div`
  max-width: 1200px;
`;

export const StyledViewPackages = styled.div`
  text-align: center;
  color: rgb(57, 135, 161);
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 4px;
  cursor: pointer;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const StyledContentBlock = styled.div`
  display: flex;
  padding: 50px 30px 20px 30px;
  border-radius: 10px;
  justify-content: space-between;
  border: 1px solid #BDBCBC;
  background: ${props => (props.domain ? '#F1FFFC' : '#FFFFFF')};

  ${breakpoint('mobile', 'desktop')`
    flex-direction: column;
    margin-top: 10px;
    padding: 3%;
  `}
`;
export const StyledMobileView = styled.div`
  display: none;
 ${breakpoint('mobile', 'desktop')`
    display: flex;
    padding: 50px 30px 20px 30px;
    border-radius: 10px;
    justify-content: space-between;
    border: 1px solid #BDBCBC;
    flex-direction: column;
    margin-top: 15px;
    padding:1%;
    padding-left:15px;
  `}
`;

export const ImageBlock = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 2%;
  flex:0 0 20%;
  ${breakpoint('mobile', 'desktop')`
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
    width: 100%;
  `}
`;

export const DoctorName = styled.h1`
  font-size: 28px;
  color: ${props => (props.domain ? 'rgb(0, 81, 78)' : '#26BED2')};
  font-weight: 700;
  text-align: left;

  ${breakpoint('mobile', 'desktop')`
    text-align: center;
    margin-bottom: 10px;
    font-size: 20px;
  `}

  @media (min-width:400px) and (max-width: 550px){
    font-size: 24px;
  }

  @media (max-width: 400px){
    font-size: 22px;
  }

  @media (min-width:550px) and (max-width: 736px){
    font-size: 25px;
  }
`;
export const StyledDoctorInfo = styled.div`
  color:#858E96;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  margin: 2% 0%;
  justify-content: flex-start;
  ${breakpoint('mobile', 'tablet')`
    display:none;
  `}
  ${breakpoint('tablet', 'desktop')`
    justify-content:center;
    margin: 1% 0%;
  `}
`;

export const StyledDoctorInfoMobile = styled.div`
  display: none;
  ${breakpoint('mobile', 'tablet')`
    text-transform: capitalize;
    color:#858E96;
    font-size: 20px;
    font-weight: 600;
    display: flex;
    margin: 5px 0px;
    font-size: 14px;
    font-weight: 600;
    justify-content:center;
  `}

`;

export const DoctorPost = styled.div`
  text-align: center;
  padding-right:3%;
  ${breakpoint('mobile', 'tablet')`
  line-height: 1.5;
  `}
  @media(min-width:400px) and (max-width: 550px){
    font-size: 15px;
  }

  @media (max-width: 400px){
    font-size: 14px;
  }

  @media (min-width:550px) and (max-width: 736px){
    font-size: 18px;
  }
`;

export const Hospital = styled(HospitalImage)`
  padding-right: 6px;
  height:22px;
  width: 22px;
  ${breakpoint('mobile', 'desktop')`
   height:20px;
  width: 20px;
  `}
`;

export const LocationImage = styled(IconLocation)`
  padding-right: 6px;
  height:22px;
  width: 17px;
    ${breakpoint('mobile', 'desktop')`
    height:20px;
  `}
`;

export const DoctorAttributes = styled.div`
  white-space:nowrap;
  ${breakpoint('mobile', 'desktop')`
    white-space:normal;
  `}
`;

export const DoctorIcon = styled(DoctorImageIcon)`
  padding-right: 6px;
  height:22px;
  width: 19px;
  ${breakpoint('mobile', 'desktop')`
    height:20px;
    width:20px;
  `}
  @media (min-width:500px)and (max-width:890px)
  {
    height:28px;
    width:20px;
  }
  @media (min-width:890px) and (max-width:1024px){
    height: 31px;
  }
`;

export const DepartmentImage = styled(DepartmentIcon)`
  padding-right: 6px;
  height:22px;
  width: 24px;
  ${breakpoint('mobile', 'desktop')`
    height:20px;
    width: 20px;
  `}
`;

export const PlayImage = styled(PlayIcon)`
  width: 25px;
  margin-right: 4%;
  ${breakpoint('mobile', 'desktop')`
    width: 20px;
  `}  
`;

export const StyledPlay = styled.div`
  font-weight: 600;
  color: #515151;
  font-size: 20px;
  position: absolute;
  top: 87%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 15px;
  padding: 3%;
  display: flex;
  align-items: center;
  & :hover{
  cursor: pointer;
  }
  ${breakpoint('mobile', 'desktop')`
    font-size:15px;
    top:97%;
    left:50%;
    border-radius: 30%;
    padding: 1.5%;
  `}
`;

export const StyledPlan = styled.div`
  margin: 5% 0%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size:20px;
  font-weight: 500;
  border-radius: 5%;
  border: 1px solid #EAEAEA;
  
`;

export const StyledBook = styled.div`
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  flex:1;
  padding:2%;
  font-size: 15px;
  border-radius: 10px;
  margin: 1%;
  color: ${theme.colors.white};
  & :hover{
  cursor: pointer;
}
  background-image:${props => (props.domain
    ? `
    linear-gradient(
    118.6deg,
    #5BA0A0 2%,
    #448989 30%,
    #276363 66%,
    #144D4D 100%
  )` : `linear-gradient(
    118.6deg,
    #63aecf 0%,
    #629ece 30.63%,
    #458fd3 63.31%,
    #3a78b1 98.02%
  )`)};
  @media (max-width:370px){
    padding:6px;
    font-size: 11px;
    border-radius: 5px;
  }
  @media  (max-width:450px){
    font-size: 13px;
  }
  @media (min-width:450px) and (max-width:700px){
    font-size:15px;
  }
  ${breakpoint('tablet', 'desktop')`
    padding:10px;
  `}
`;

export const StyledTreatmentText = styled.div`
  line-height: 1.5;
  flex:0 0 75%;
  font-weight: 600;
  font-size: 18px;
  padding-left: 1%;
  ${breakpoint('mobile', 'tablet')`
    flex:0 0 73%;
  `}
   @media (max-width:330px){
    flex:0 0 66%;
   }
   @media (max-width:514px){
    line-height:1.2;
    font-size:13px;
    flex:0 0 70%;
   }
  @media (min-width:514px) and (max-width:700px){
    font-size:14px;
  }
  ${breakpoint('tablet', 'desktop')`
    font-size: 15px;
    flex:0 0 70%;
  `}
`;

export const StyledVideoIcon = styled(VideoImage)`
  width:20px;
  margin: 0% 6%;
  ${breakpoint('mobile', 'tablet')`
    width:15px;
  `}
  @media (max-width:514px){
    margin: 0% 3%;
   }
`;

export const StyledWrittenIcon = styled(WrittenImage)`
  width:20px;
  margin: 0% 6%;
  ${breakpoint('mobile', 'tablet')`
    width:15px;
  `}
   @media (max-width:514px){
    width:13px;
    margin: 0% 3%;
   }
`;

export const StyledBooked = styled.div`
`;

export const VideoAppointmentImage = styled(VideoAppointment)`
  width: 20px;
  margin:0% 1%;
`;

export const StyledVideoAppointment = styled.div`
  color:#5A5F64;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  margin: 2% 0%;
  justify-content: flex-start;
  align-items: center;
  ${breakpoint('mobile', 'tablet')`
    text-align:center;
    flex-direction:column;
    font-weight:650;
  `}
    ${breakpoint('tablet', 'desktop')`
    justify-content:center;
    margin: 1% 0%;
  `}
  @media(min-width:500px) and (max-width:650px){
    font-size: 22px;
  }

  @media(min-width:650px) and (max-width:736px){
    font-size: 26px;
  }
`;

export const StyledVideoBookNow = styled.div`
  display: flex;
  align-items: center;
  padding:1%;
  font-size: 15px;
  border-radius: 10px;
  margin: 0% 3%;
  color: ${theme.colors.white};
  & :hover{
  cursor: pointer;
}
  background-image:${props => (props.domain
    ? `linear-gradient(
    118.6deg,
    #5BA0A0 2%,
    #448989 30%,
    #276363 66%,
    #144D4D 100%
  )` : ` 
    linear-gradient(
    118.6deg,
    #63aecf 0%,
    #629ece 30.63%,
    #458fd3 63.31%,
    #3a78b1 98.02%
  )`)};
  ${breakpoint('mobile', 'tablet')`
    margin:3%;
    padding:3%;
    font-size:16px;
  `}
  ${breakpoint('tablet', 'desktop')`
    padding:7px;
  `
}

  @media(min-width:450px) and (max-width:600px){
    padding:2%;
    font-size:18px;
  }
  @media(min-width:600px) and (max-width:736px){
    padding:2%;
    font-size:20px;
  }
`;

export const StyledHeadTitle = styled.span`
  ${mb(3)}
  color: ${colors.mediumGray};
  display: block;
  font-size: 18px;
  text-transform: uppercase;
  text-align: center;
  ${breakpoint('desktop')`
    font-size: 20px;
    text-align: right;
  `}
`;

export const StyledHeadSubtitle = styled.p`
  ${mb(2.5)}
  ${theme.typography.Raleway}
  font-size: 24px;
  text-align: center;
  ${breakpoint('desktop')`
    text-align: right;
  `}
`;

export const Heading = styled.h2`
  font-size: 32px;
  font-weight: 600;
  color: #4A4949;

  ${breakpoint('mobile', 'tablet')`
    font-size: 25px;
  `}
`;

export const DoctorSpeciality = styled.h2`
  font-size: 34px;
  color: #4A4949;
  font-weight: 700;

  ${breakpoint('mobile', 'desktop')`
    font-size: 30px;
    text-align: center;
  `}

  @media(max-width: 550px){
    font-size: 28px;
    text-align: center;
  }

  @media(max-width: 400px){
    font-size: 22px;
  }
  
  
`;

export const DoctorDetailsBlock = styled.div`
  flex:1;
  display: flex;
  flex-direction: column;
  padding-left: 2%;
  padding-right: 2%;
${breakpoint('mobile', 'desktop')`
    justify-content: center;
  `}
`;

export const StyledHorizontalLine = styled.hr`
  border-top: 1px solid #BDBCBC;
  width:95%;
`;

export const StyledContentHeading = styled.div`
  margin: 3% 0%;
  font-weight: 700;
`;

export const DoctorValues = styled.div`
  width:fit-content;
  line-height: 1.2;
  display: flex;
  align-items: center;
  padding:5px 10px;
  color: #858E96;
  border-radius: 15px;
  font-weight: 600;
  margin:5px 0px;
  background: #F7F7F7;
  ${breakpoint('mobile', 'desktop')`
  color:#373737;
  padding:0px;
  background:none;
  width:auto;
  line-height:1.3;
  margin:5px 0px;
  `}

  @media(min-width:400px) and (max-width: 550px){
    font-size: 14px;
  }

  @media (max-width: 400px){
    font-size: 14px;
  }

  @media (min-width:550px) and (max-width: 736px){
    font-size: 16px;
  }
`;
export const StyledBlock = styled.div`
  display: flex;
  margin-top: 30px;
  justify-content: center;
  ${breakpoint('mobile', 'desktop')`
  margin-top: 0px;
  `}
`;

export const StyledContentDiv = styled.div`
  margin-right: 20px;
  display: flex;
  flex-direction: column;
  color:#373737;
  align-items: stretch;
  ${breakpoint('mobile', 'desktop')`
    margin-right: 0px;
  `}
`;

export const Div2 = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
`;

export const StyledContentBox = styled.div`
  padding: 16px 0px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  ${breakpoint('mobile', 'desktop')`
    display:none;
  `}
`;

export const DoctorSection = styled.div`
  margin-top: 30px;
  align-items: space-between;
`;
export const Styledform = styled.div`
  width: 45%;
  padding: 16px;
  ${breakpoint('mobile', 'desktop')`
    display: none;
  `}
`;

export const ContentBlock = styled.div`
  ${{ RichTextStyle }}
  margin-top: 30px;
  background: ${props => (props.domain ? '#F1FFFC' : '#EDF8FFCC')};
  border: 1px solid #E2E8EA;
  width: 95.5%;
  padding: 14px 26px;
  line-height: 30px;
  border-radius: 10px;

  ${breakpoint('mobile', 'tablet')`
    width: 93%;
    padding:3%;
    margin-left: auto;
    margin-right: auto;
    & p, li,ul{ 
    &:: marker{
    color:#85BAD6;
  }
  } 
  p, li, ul ,ul li{
  font-size: 16px !important;
}
  `}

${breakpoint('tablet', 'desktop')`
  width: 93%;
  margin-left: auto;
  margin-right: auto;
`}
`;

export const HighlightsBlockContent = styled.div`
  margin-top: 30px;
  background: ${props => (props.domain ? '#F1FFFC' : '#EDF8FFCC')};
  border: 1px solid #E2E8EA;
  width: 90%;
  padding: 15px 10px;
  line-height: 30px;
  border-radius: 10px;
  font-size: 22px;

${breakpoint('mobile', 'desktop')`
  width: 93%;
  margin-left: auto;
  margin-right: auto;
`}

@media(max-width: 800px){
  font-size: 20px;
  line-height: 26px;
}

@media(max-width: 550px){
  font-size: 18px;
  line-height: 24px;
}

@media(max-width: 450px){
  font-size: 16px;
  line-height: 22px;
}

@media(max-width: 380px){
  font-size: 14px;
  line-height: 20px;
}
`;

export const HiddenBlock = styled.div``;

export const DoctorImage = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${breakpoint('mobile', 'desktop')`
    width: 100%;
  `}
`;

export const DoctorImg = styled.img`
  border-radius: 7%;
  width:200px;
  height: 200px;

  ${breakpoint('mobile', 'desktop')`
    width: 100%;
    border-radius:10%;
    margin:0% 20%; 
  `}

  @media(max-width: 1024px){
    max-width:200px;
    max-height: 200px;
  }
  @media(max-width: 400px){
    height: 180px;
  }
  @media(max-width: 300px){
    height: 160px;
  }
   @media(max-width: 220px){
    height: 110px;
  }
`;

export const DoctorLeftBlock = styled.div`
  width: ${props => (props.block ? '75%' : '60%')};
  padding: 16px;

  ${breakpoint('mobile', 'desktop')`
    width: 100%;  
    padding:0%;
  `}
`;

export const Procedures = styled(Grid)`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: flex-start;
  ${breakpoint('mobile', 'desktop')`
    display: none;
  `}
`;
export const ProceduresMobileView = styled(Grid)`
  display: none;
  ${breakpoint('mobile', 'desktop')`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content:space-between;
  flex-direction:column;
`}
`;

export const Item = styled.div`
  margin: 1% 1%;
  color: #5FA6BF;
  border: 1px solid #EAEAEA;
  width: auto;
  border-radius: 12px;
  padding: 12px;
  font-size: 16px;
  font-weight: 600;

  & :hover{
  cursor: pointer;
}

  ${breakpoint('mobile', 'desktop')`
  text-decoration: underline;
  text-underline-offset: 4px;
  border-radius: 0px;
  border:none;
  width: none;
  margin:2% 0%;
  font-size:14px;
  padding:0px;
  `}
   ${breakpoint('tablet', 'desktop')`
    margin:10px 0px;
    font-size:14px;
    padding: 0px;
  `}
`;
export const DoctorProcedures = styled.div`
  width: 94%;
  margin-top: 40px;
  ${breakpoint('mobile', 'tablet')`
    width: 100%;
    font-size:20px;
    margin:15px 0px;
  `}
  ${breakpoint('tablet', 'desktop')`
    margin-top:20px;
  `}
`;

export const HighlightsBlock = styled.div`
  margin-top: 40px;
`;

export const DoctorHeading = styled.h2`
  padding:2%;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  color: ${theme.colors.grayText};

  @media(max-width: 750px){
    font-size: 18px;
  }

  @media(max-width: 550px){
    font-size: 16px;
  }

  @media(max-width: 450px){
    font-size: 14px;
  }

  @media(max-width: 360px){
    font-size: 12px;
  }
`;

export const DoctorFacilityBlock = styled.div`
  margin-top: 40px;
  ${breakpoint('mobile', 'desktop')`
     margin-bottom:10px;
  `}
`;
export const FacilityBlock = styled.div`
  box-shadow: 0px 3px 10px rgb(0 0 0/0.2);
  margin-top: 8px;
  padding: 16px;
  border-radius: 10px;
`;

export const FacilityName = styled.div`
  font-size: 28px;
  font-weight: 600;
  color: #333333;
  display: flex;
  margin: auto; 
  display: flex;
  flex-direction: column;
  ${breakpoint('mobile', 'tablet')`
    font-size:20px;
    line-height: 24px; 
    font-weight:700;
  `}
  @media(max-width: 750px){
    font-size: 24px;
  }

  @media(max-width: 550px){
    font-size: 22px;
    line-height: 28px;
  }

  @media(max-width: 380px){
    font-size: 18px;
    line-height: 24px;  
  }
`;

export const FacilityContentBlock = styled.div`
  display: flex;
  margin-top: 20px;
  justify-content: space-around;
  align-items: center;
  align-items: flex-start;
  ${breakpoint('mobile', 'desktop')`
    flex-direction: column-reverse;
    align-items: center;
    justify-content: center;
  `}
`;

export const Content = styled.div`
  width: 40%;
  padding: 10px;
  height: 80%;  
  ${breakpoint('mobile', 'desktop')`
    width: 100%;
    margin-top: 10px;
  `}
`;

export const FacilityImage = styled.div`
  width: 45%;
  height: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${breakpoint('mobile', 'desktop')`
    width: 100%;
  `}
`;

export const FacilityImg = styled.img`
  width:100%;
  height: 300px;
  background-size: fit;

  border-radius: 12px;

  @media(max-width: 1175px){
    width: 500px;
    height: 250px;
  }

  @media(max-width: 950px){
    width: 80%;
    height: 300px;
  }

  @media(max-width: 785px){
    width: 100%;
    height: 300px;
  }
`;

export const StyledList = styled.ul`
  ${pl(4)};
  list-style-type: disc;
  font-size: 22px;
  line-height: 30;
`;

export const StyledListItem = styled.li`
  ${({ variant }) => (variant === 'small' ? mb(2) : mb(3))}

  &:: marker{
    color:#85BAD6;
  }
  line-height: 1.3;
  &:last-child {
    ${mb(0)}
  }

  @media(max-width: 750px){
    font-size: 20px;
  }

  @media(max-width: 550px){
    font-size: 18px;
  }

  @media(max-width: 450px){
    font-size: 16px;
  }

  @media(max-width: 380px){
    font-size: 14px;
  }
`;

export const HighlightContentBlock = styled.div`
 
  width: 100%;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  flex-direction: column;
  overflow: hidden;
  -webkit-line-clamp: 10;
  ${breakpoint('mobile', 'desktop')`
    overflow: hidden;
    display: block;
    line-height: calc(1.5rem*3);
    height:4.5rem;
  `}
`;

export const StyledParagraph = styled.p`
  font-size: 20px;
`;

export const FacilityLocation = styled.div`
  margin-top: 10px;
  height: 35px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  ${breakpoint('mobile', 'tablet')`
    display:none;
  `}
`;

export const Location = styled.div`
  font-size: 22px;
  font-weight: 500;
  margin-left: 12px;

  @media(max-width: 550px){
    font-size: 20px;
  }

  @media(max-width: 380px){
    font-size: 18px;
    margin-left: 10px;
  }
`;

export const LocationIconImg = styled(IconLocation)`
  height: 22px;
  @media(max-width: 550px){
    height: 20px;
    width: 20px;
  }

  @media(max-width: 380px){
    height: 18px;
   
  }
`;

export const FacilityLocationBlock = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 1%;
  ${breakpoint('mobile', 'desktop')`
    width: 100%;
  `}
`;

export const FacilityLink = styled.div`
& :hover{
  color: #56A1BB;
  cursor: pointer;
}
`;
export const FacilityLocationMobile = styled.div`
  display:none;
  ${breakpoint('mobile', 'tablet')`{
  margin-top:10px;
  height: 35px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`}

`;
export const SeeMoreButton = styled.div`
  color: ${props => (props.domain ? 'rgb(0, 81, 78)' : '#56A1BB')};
  font-size: 20px;
  margin-top: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  margin-right:10px;
  ${pl(4)};

  @media(max-width: 550px){
    font-size: 18px;
  }

  @media(max-width: 380px){
    font-size: 16px;
  }
`;

export const HiddenStyledForm = styled.div`
  display: none;
  @media (min-width:600px) and (max-width:1024px){
    margin:0% 15%;
  }
  ${breakpoint('mobile', 'desktop')`
    display: flex;
    margin-top: 40px;
    justify-content: center;
  `}
  
`;

export const FormMini = styled.div`
  position: sticky;
  top: 80px;
`;

export const StyledFlexCenter = styled(Grid)`
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
`;

export const StyledSeeMore = styled.a`
  font-size: 22px;
  color: #2485a6;
  cursor: pointer;
  margin: 0 auto;
  @media screen and (max-width: 400px) {
    font-size: 5vw;
  }
`;
export const StyledCoverMaxWidthNoBottomMargin = styled.div`
  max-width: 1400px;
  margin: 30px 0px;
  width: 100%;
`;

export const StyledDoctorGrid = styled(Grid)`
  ${breakpoint('mobile', 'tablet')`
    width: 200%;
    ${({ scroll }) => scroll && 'transform: translateX(-50%)'};
    transition: 0.3s;
`}

  ${breakpoint('desktop')`
    min-height: 665px;
 `}
`;

export const StyledPackagesMobile = styled.div`
  margin-top: 20px;
`;

export const StyledOverFlowScroll = styled.div`
  overflow: hidden;
  width: 100%;
`;

export const StyledArrowWrapper = styled.div`
  width: calc(100% - 40px);
  position: relative;
  padding: 0 20px;
`;

export const MainSubHealine = styled.h3`
  padding-top: 2.5rem;
  color:black;
  text-align: center;
  margin-top: 30px;
  font-size: 32px;
  line-height: 1.2;
  font-weight: 700;
  margin-bottom: 1rem;
  ${breakpoint('tablet', 'desktop')`
    font-size: 22px;
  `}
  ${breakpoint('mobile', 'tablet')`
    padding-top: 1.5rem;
    font-size: 18px;
    margin-bottom: 1.5rem;
  `}
`;

export const LeftArrow = styled(MoveLeftArrow)`
  position: absolute;
  left: 0;
  top: 50%;
  width: 30px;
  height: 30px;
  ${breakpoint('tablet')`
    display: none;
   `}
`;

export const RightArrow = styled(MoveRightArrow)`
  position: absolute;
  right: 0px;
  top: 50%;
  width: 30px;
  height: 30px;
  ${breakpoint('tablet')`
    display: none;
   `}
`;


const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Loader = styled.div`
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 80px;
  height: 80px;
  -webkit-animation: ${spin} 2s linear infinite; /* Safari */
  animation: ${spin} 2s linear infinite;
  margin: 0 auto;
  ${breakpoint('mobile', 'desktop')`
    width: 50px;
    height: 50px;
    border: 8px solid #f3f3f3;
    border-top: 6px solid #3498db;
  `}
`;

export const StyledRichTextContent = styled.div`
  ${RichTextStyle}
  & p{ 
  font-size:16px !important;
}
`;

export const StyledBulletListWrapper = styled.div`
`;
